import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Breadcrumb, Card, Icon, Image, Label, List, Menu, Search } from 'semantic-ui-react';
import PageContainer from '../common/PageContainer';
import * as selectors from '../../redux/selectors';
import * as actions from '../../redux/actions';
import AddUserDialog from './AddUserDialog';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import Fuse from 'fuse.js';

export const AdminAllUsers = ({ users, getUsers, history }) => {
  // eslint-disable-next-line
  useEffect(getUsers, []);
  const [results, setResults] = useState([]);

  const fuse = new Fuse(
    users.filter(u => !u.isDisabled),
    {
      includeScore: true,
      threshold: 0.3,
      keys: ['username', 'email', 'name'],
    }
  );

  const getColor = role => {
    console.log(role);
    switch (role.name) {
      case 'admin':
        return 'red';
      case 'editor':
        return 'blue';
      default:
        return '';
    }
  };

  const resultRenderer = ({ name, email, roles }) => (
    <div style={{ width: 500 }}>
      <div>{name}</div>
      <div style={{ fontSize: 12, color: 'grey' }}>{email}</div>
      <div>
        {roles.map(role => (
          <Label content={role.name.charAt(0).toUpperCase() + role.name.slice(1)} size="tiny" />
        ))}
      </div>
    </div>
  );

  return (
    <PageContainer>
      <Breadcrumb>
        <Breadcrumb.Section>Admin</Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section>Users</Breadcrumb.Section>
      </Breadcrumb>

      <Menu borderless>
        <Menu.Item header>
          <Icon name="user circle outline" />
          Users
        </Menu.Item>

        <Menu.Menu position="right">
          <Menu.Item>
            <AddUserDialog />
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      <Search
        placeholder="Search users"
        resultRenderer={resultRenderer}
        onResultSelect={(e, data) => {
          // navigate to user page
          const userId = data.result.id;
          history.push(`/admin/user/${userId}`);
        }}
        onSearchChange={(e, { value }) => {
          const result = fuse.search(value);
          setResults(
            result
              ?.map(i => i.item)
              .map(v => ({
                ...v,
                title: v.name,
                description: v.name,
              }))
          );
        }}
        results={results}
      />

      <Card fluid>
        <Card.Content>
          <List selection verticalAlign="middle" divided>
            {users
              .filter(u => !u.isDisabled)
              .map(user => (
                <List.Item key={user.id}>
                  <Link to={'/admin/user/' + user.id}>
                    <List.Content>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                        }}
                      >
                        <div>
                          <Image
                            avatar
                            size="tiny"
                            src={user.imageUrl || 'https://react.semantic-ui.com/images/wireframe/square-image.png'}
                          />
                          {user.name}
                        </div>

                        <div
                          style={{
                            marginLeft: 'auto',
                          }}
                        >
                          {user.roles.map(role => (
                            <Label
                              color={getColor(role)}
                              content={role.name.charAt(0).toUpperCase() + role.name.slice(1)}
                              size="tiny"
                            />
                          ))}
                        </div>
                      </div>
                    </List.Content>
                  </Link>
                </List.Item>
              ))}
          </List>
        </Card.Content>
      </Card>
    </PageContainer>
  );
};

const mapStateToProps = state => ({
  users: selectors.getUsers(state),
});

const mapDispatchToProps = dispatch => ({
  getUsers: bindActionCreators(actions.admin.getUsers, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminAllUsers);
